import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="bg-dark text-white py-24 md:py-32 relative overflow-hidden" data-id="element-61">
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-62"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/20 rounded-full blur-3xl" data-id="element-63"></div>
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-primary/10 rounded-full blur-3xl" data-id="element-64"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-65">
        <FadeIn data-id="element-66">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-8 leading-tight" data-id="element-67">
            Si llegaste hasta acá, <br className="hidden md:block" data-id="element-68" />
            <span className="text-primary" data-id="element-69">ya lo sabés.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-70">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 md:p-12 mb-12" data-id="element-71">
            <p className="text-2xl md:text-3xl font-bold mb-6" data-id="element-72">
              No necesitás más motivación. <br data-id="element-73" />
              <span className="text-primary" data-id="element-74">Necesitás un sistema.</span>
            </p>
            <p className="text-xl text-gray-300" data-id="element-75">
              Este es el momento. Empezá hoy. <br className="hidden sm:block" data-id="element-76" />
              Corré tus primeros 5K. Y dejá de abandonar.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-77">
          <CTAButton className="py-5 px-10 text-xl shadow-2xl shadow-primary/20" data-id="element-78">
            EMPEZAR AHORA →
          </CTAButton>
          <p className="mt-6 text-gray-400 text-sm" data-id="element-79">
            Acceso inmediato • Garantía de 7 días • Pago seguro
          </p>
        </FadeIn>
      </div>
    </section>;
}